import { render, staticRenderFns } from "./ButtonEditItem.vue?vue&type=template&id=3a479c3f&"
import script from "./ButtonEditItem.vue?vue&type=script&lang=js&"
export * from "./ButtonEditItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a479c3f')) {
      api.createRecord('3a479c3f', component.options)
    } else {
      api.reload('3a479c3f', component.options)
    }
    module.hot.accept("./ButtonEditItem.vue?vue&type=template&id=3a479c3f&", function () {
      api.rerender('3a479c3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/ButtonEditItem.vue"
export default component.exports